import { concatMessage } from '@/api/concat'

const state = {
  // headerTitle: '' // 新闻id
}

const mutations = {
  // SETH(state, headerTitle) {
  //   state.headerTitle = headerTitle
  // }
}

const actions = {
  concatMessage({commit}) {
    return new Promise((resolve, reject) => {
      concatMessage().then((res) => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  }
  // anchorPoint({commit}, findId) {
  //   let toElement = document.getElementById(findId)
  //   // 如果对应id存在，就跳转
  //   if (findId) {
  //     toElement.scrollIntoView()
  //   }
  // }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
